/**
 * GLINT-3D — Environnement HDRI personnalise pour le viewer 3D natif Shopify.
 *
 * Fichier 100% ajoute par GLINT : ne remplace ni ne reecrit le composant
 * <product-model>/<model-viewer> natif Horizon. Il se contente de lire des
 * attributs data-glint-* deposes sur <product-model> (voir
 * snippets/product-media.liquid) et de les appliquer sur le <model-viewer>
 * une fois que celui-ci est cree par le theme — c'est-a-dire uniquement
 * quand le visiteur clique sur le bouton play du modele 3D (comportement
 * natif inchange : assets/media.js, ProductModel.loadContent). La HDRI
 * (6 Mo) n'est donc jamais recuperee avant que le visiteur interagisse avec
 * le viewer.
 *
 * Points de montage a surveiller en cas de mise a jour du theme Horizon :
 *  - snippets/product-media.liquid (attributs data-glint-* sur <product-model>)
 *  - snippets/product-media-gallery-content.liquid (balise <script> qui inclut ce fichier)
 *  - config/settings_schema.json (groupe de reglages "GLINT — Visionneuse 3D")
 */
(function () {
  'use strict'; // GLINT-3D

  /* GLINT-3D — GARDE D'EXECUTION UNIQUE (28/08). Le gabarit de galerie
     (snippets/product-media-gallery-content.liquid) est rendu plusieurs fois
     par page (grille + fenetre de zoom) et repose sa balise <script> a
     chaque fois : ce fichier s'executait DEUX fois, donc preloadEnvironment
     partait en double. Les deux requetes identiques etant simultanees,
     Chrome n'en gardait AUCUNE en cache — le modele etait ensuite
     retelecharge deux fois de plus a l'ouverture. Mesure avant correctif :
     4 x 8,25 Mo de GLB et 2 x 6,34 Mo de HDRI sur une seule fiche. */
  if (window.__glintViewer3D) return;
  window.__glintViewer3D = true;

  /**
   * GLINT-3D: model-viewer choisit son decodeur HDR en testant si l'URL SE
   * TERMINE par ".hdr". Or Shopify Files ajoute systematiquement un
   * cache-buster "?v=1234" a la fin de l'URL, ce qui casse cette detection :
   * le .hdr est alors charge comme une image ordinaire, le decodage echoue
   * silencieusement et l'environnement reste vide — un metal poli miroir ne
   * reflechissant que l'environnement s'affiche alors entierement noir.
   * On retire donc la query string, mais uniquement pour les fichiers .hdr
   * (l'URL Shopify Files reste valide sans le "?v=").
   * @param {string} url
   * @returns {string}
   */
  function stripHdrCacheBuster(url) {
    var queryIndex = url.indexOf('?');
    if (queryIndex === -1) return url;

    var pathPart = url.slice(0, queryIndex);
    if (/\.hdr$/i.test(pathPart)) return pathPart;

    return url;
  }

  /**
   * Applique les attributs GLINT (HDRI / exposure / tone-mapping) sur un
   * <model-viewer> a partir des data-attributs portes par son
   * <product-model> parent.
   * @param {Element} modelViewerEl
   */
  /* GLINT VITESSE (24/09, decision client) : sur telephone (749 px ou
     moins), la HDRI allegee 1k (1,6 Mo au lieu de 6,3 Mo) si le porteur en
     fournit une. Meme image, reduite. L'ordinateur garde la 2k. Sert au
     viewer ET au prechauffage : les deux doivent demander la MEME URL, sinon
     le prechauffage remplit une autre entree de cache. */
  function hdriPourEcran(host) {
    var mobile = host.dataset.glintEnvImageMobile;
    if (mobile && window.matchMedia('(max-width: 749px)').matches) return mobile;
    return host.dataset.glintEnvImage || '';
  }

  function applyGlintEnvironment(modelViewerEl) {
    // GLINT-3D: evite un double traitement du meme <model-viewer>
    if (modelViewerEl.dataset.glintApplied === 'true') return;

    // Deux contextes : la page produit enveloppe le viewer dans un
    // <product-model> porteur des reglages ; la page bundle genere ses
    // <model-viewer> directement, et depose alors les reglages sur un
    // element dedie [data-glint-3d-config]. Sans ce repli, la HDRI ne
    // s appliquait que sur la page produit.
    var host =
      modelViewerEl.closest('product-model') ||
      document.querySelector('[data-glint-3d-config]');
    if (!host) return;

    var envImage = hdriPourEcran(host);
    var exposure = host.dataset.glintExposure || '';
    var toneMapping = host.dataset.glintToneMapping || '';

    // GLINT-3D: HDRI dediee aux reflets/eclairage uniquement. On ne pose
    // volontairement jamais skybox-image : le fond du viewer reste celui
    // gere nativement par le theme.
    if (envImage) {
      modelViewerEl.setAttribute('environment-image', stripHdrCacheBuster(envImage)); // GLINT-3D
    }

    // GLINT-3D: exposition, pour faire ressortir les hautes lumieres sur
    // l'inox poli miroir (le reglage par defaut de model-viewer les ecrase).
    if (exposure) {
      modelViewerEl.setAttribute('exposure', exposure);
    }

    // GLINT-3D: tone mapping (ex. "commerce" = contraste/hautes lumieres
    // accentues, pense pour la photo produit sur matieres reflechissantes).
    if (toneMapping) {
      modelViewerEl.setAttribute('tone-mapping', toneMapping);
    }

    // GLINT-3D: Shopify genere pour chaque modele une image d attente de
    // 100x100 au fond BLANC OPAQUE (verifie : coin a rgba(255,255,255,255)).
    // Sur une galerie beige et des visuels transparents, ce carre blanc se
    // voyait avant le chargement de la 3D. On la retire donc, et on neutralise
    // aussi la couleur de fond que model-viewer applique par defaut derriere.
    modelViewerEl.removeAttribute('poster');
    modelViewerEl.style.setProperty('--poster-color', 'transparent');

    // GLINT-3D: des que le <model-viewer> apparait — donc des l ouverture
    // de la fenetre d apercu sur la page bundle — on prechauffe le .glb.
    // On ne peut pas se contenter de passer reveal a "auto" : la diapositive
    // 3D est masquee tant qu on ne la selectionne pas, et model-viewer ne
    // charge rien tant qu il n est pas visible. Remplir le cache HTTP
    // contourne le probleme sans toucher au comportement natif.
    // GLINT-3D: 'eager' fait charger le modele meme si la diapositive est
    // encore masquee. Par defaut model-viewer attend la visibilite, ce qui
    // decalait tout le telechargement au moment du clic sur l onglet 3D.
    if (!slowConnection()) modelViewerEl.setAttribute('loading', 'eager');

    /* GLINT-3D (28/08, retour client) : la molette au-dessus du viewer
       ZOOMAIT la camera au lieu de faire defiler la page — on descendait,
       on tombait dans la vignette, la page se bloquait et il fallait
       ressortir le curseur pour repartir. `disable-zoom` rend la molette
       a la page et garde le glisser-tourner, qui est le seul geste utile
       sur un tirage. C'est deja le reglage du Mirror Moment et du Wall
       Studio : la fiche produit etait la derniere a ne pas l'avoir. */
    modelViewerEl.setAttribute('disable-zoom', '');

    /* GLINT-3D (28/08) : on ne prechauffe PLUS le .glb ici. Ce
       fetch partait dans le meme tick que le chargement du
       <model-viewer> lui-meme : deux requetes concurrentes sur la meme
       URL, donc un telechargement entier en pur doublon (mesure : les
       deux a 8,25 Mo, aucune servie par le cache). Prechauffer n'a de
       sens qu'AVANT, a distance — c'est le role de schedulePreload.
       Le viewer porte loading="eager" : il va chercher le fichier seul. */

    // GLINT-3D: la barre de chargement par defaut de model-viewer (un trait
    // gris sous le modele) n'apporte rien — le poster couvre l'attente.
    // Un slot vide la remplace definitivement, sur toutes les pages.
    if (!modelViewerEl.querySelector('[slot="progress-bar"]')) {
      var progressSlot = document.createElement('div');
      progressSlot.setAttribute('slot', 'progress-bar');
      modelViewerEl.appendChild(progressSlot);
    }

    modelViewerEl.dataset.glintApplied = 'true'; // GLINT-3D

    reviveWhenVisible(modelViewerEl); // GLINT-3D
  }

  /**
   * GLINT-3D: relance un viewer 3D ne dans un conteneur masque.
   *
   * Sur la page bundle, la fenetre d'apercu monte toutes ses diapositives d'un
   * coup et masque celles qui ne sont pas actives. Le <model-viewer> est donc
   * initialise en display:none — et dans ce cas sa boucle de rendu ne demarre
   * jamais, meme lorsque la diapositive redevient visible. Le modele apparait
   * alors comme une image figee : impossible de le faire tourner.
   *
   * On le reconnecte donc au DOM des qu'il devient visible pour la premiere
   * fois : le navigateur rejoue son cycle de vie, et le rendu part.
   * L'operation n'a lieu qu'une seule fois par element, et jamais si le
   * viewer etait deja visible a sa creation (cas de la page produit).
   *
   * @param {Element} modelViewerEl
   */
  function reviveWhenVisible(modelViewerEl) {
    if (modelViewerEl.dataset.glintRevive) return;
    if (typeof IntersectionObserver !== 'function') return;

    // Deja visible a l'initialisation : le rendu a demarre normalement.
    if (modelViewerEl.getBoundingClientRect().width > 0) {
      modelViewerEl.dataset.glintRevive = 'inutile';
      return;
    }

    modelViewerEl.dataset.glintRevive = 'en-attente';

    var reviveObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        reviveObserver.disconnect();

        var element = entry.target;
        if (element.dataset.glintRevive === 'fait') return;
        element.dataset.glintRevive = 'fait';

        var parent = element.parentElement;
        if (!parent) return;

        // On repere la position exacte pour la restituer a l'identique.
        var nextSibling = element.nextSibling;

        // Un clone, et non le meme element : re-inserer l'original ne relance
        // rien, model-viewer conserve son etat interne. Seul un element neuf
        // repart proprement.
        var fresh = element.cloneNode(true);
        fresh.removeAttribute('data-glint-applied');
        fresh.removeAttribute('data-glint-revive');
        fresh.removeAttribute('loading');
        fresh.dataset.glintRevive = 'fait';

        window.requestAnimationFrame(function () {
          parent.removeChild(element);
          parent.insertBefore(fresh, nextSibling);
        });
      });
    });

    reviveObserver.observe(modelViewerEl);
  }

  /**
   * Cherche un <model-viewer> fraichement ajoute dans un noeud (et ses
   * descendants) pour lui appliquer l'environnement GLINT.
   * @param {Node} node
   */
  function scanNode(node) {
    if (!(node instanceof Element)) return;

    if (node.tagName === 'MODEL-VIEWER') {
      applyGlintEnvironment(node);
    }

    if (node.querySelectorAll) {
      node.querySelectorAll('model-viewer').forEach(applyGlintEnvironment);
    }
  }

  // GLINT-3D: le <model-viewer> natif n'existe pas au chargement de la page ;
  // Shopify le cree seulement quand le visiteur clique sur le bouton play du
  // modele 3D. On observe donc le DOM pour reagir a cet ajout, sans jamais
  // forcer le chargement du modele ni de la HDRI avant cette interaction.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(scanNode);
    });
  });

  // ---------------------------------------------------------------------
  // GLINT-3D: prechargement de la HDRI et du modele
  // ---------------------------------------------------------------------

  var envPreloadStarted = false; // GLINT-3D

  /* GLINT-3D (28/08) : la promesse du prechauffage en cours. L'ouverture
     automatique du viewer l'attend — sans quoi les deux partent dans la
     meme seconde sur la meme URL et le fichier est telecharge DEUX fois
     (mesure : 2 x 8,25 Mo au moment du defilement). */
  var prechauffage = null;

  /**
   * GLINT-3D: vrai si l on ne doit pas imposer de gros telechargement —
   * mode economie de donnees ou connexion lente.
   */
  function slowConnection() {
    var connection = navigator.connection;
    if (!connection) return false;
    if (connection.saveData) return true;
    return ['slow-2g', '2g', '3g'].indexOf(connection.effectiveType) !== -1;
  }

  /**
   * GLINT-3D: remplit le cache HTTP a l'avance, en tache de fond, pour que
   * la 3D s'affiche d'un coup quand le visiteur y arrive.
   * @param {Element} [host]
   */
  function preloadEnvironment(host) {
    if (envPreloadStarted) return;

    if (!host) host = document.querySelector('product-model[data-glint-preload-env="true"]');
    if (!host) return;

    /* GLINT-3D (28/08) : si un viewer est deja ouvert (ou en cours), c'est
       lui qui telecharge — prechauffer par-dessus ferait le doublon que
       toute cette mecanique cherche a eviter. */
    if (document.querySelector('model-viewer')) return;
    if (host.dataset.glintAutoActivated === 'true') return;

    var envImage = hdriPourEcran(host);
    if (!envImage) return;

    if (slowConnection()) return; // GLINT-3D: economie de donnees / 3G

    envPreloadStarted = true;

    // GLINT-3D: meme URL (cache-buster retire) que celle posee sur le
    // <model-viewer>, sinon le prechargement remplirait une autre entree de
    // cache et ne servirait a rien.
    var attentes = [warmCache(stripHdrCacheBuster(envImage))];

    // GLINT-3D: et le modele lui-meme, la piece la plus lourde. Le
    // <model-viewer> vit dans un <template> inerte : rien n'y est
    // telecharge tant qu'on ne le clone pas, mais on peut lire son src.
    var template = host.querySelector('template');
    var pendingViewer = template && template.content.querySelector('model-viewer');
    var modelSrc = pendingViewer && pendingViewer.getAttribute('src');
    if (modelSrc) attentes.push(warmCache(modelSrc));

    prechauffage = Promise.all(attentes);

    /* GLINT-3D (28/08) : le fichier est en cache — on monte la piece
       IMMEDIATEMENT, sans attendre que le visiteur la croise. L'icone 3D
       posee sur la photo disparait, et il tombe sur un objet deja
       manipulable au lieu d'un bouton a presser. */
    prechauffage.then(function () {
      prechauffage = null; // plus rien a attendre : le cache est chaud
      monterLesPieces();
    });
  }

  /**
   * GLINT-3D: monte la piece 3D sur toutes les instances visibles.
   * Les copies masquees de la galerie (fenetre de zoom) ont une boite
   * vide et sont ignorees par autoActivate.
   */
  function monterLesPieces() {
    var mode = document.querySelector('product-model[data-glint-autoplay]');
    if (!mode || mode.dataset.glintAutoplay === 'off') return;

    var hotes = document.querySelectorAll('product-model');

    /* GLINT-3D (28/08, bug mesure) : monter la piece DES QUE LE FICHIER EST
       LA semblait la meilleure idee — sauf qu'un <model-viewer> initialise
       HORS ECRAN ne demarre jamais sa boucle de rendu, et le canevas reste
       vide meme quand on arrive dessus (mesure : 25 Ko de pixels au lieu
       de plus de 100). C'est le meme piege que le viewer masque du Wall
       Studio. On monte donc a l'entree dans l'ecran — le fichier etant
       deja en cache, l'apparition est immediate et le visiteur ne voit
       jamais l'icone 3D. */
    if (typeof IntersectionObserver !== 'function') {
      hotes.forEach(autoActivate);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          autoActivate(entry.target);
        });
      },
      { rootMargin: '0px', threshold: 0.2 }
    );

    hotes.forEach(function (hote) {
      io.observe(hote);
    });
  }

  /**
   * GLINT-3D: remplit le cache HTTP sans rien afficher. Le corps de la
   * reponse DOIT etre consomme, sinon le navigateur peut abandonner le
   * telechargement avant de l'ecrire en cache.
   * @param {string} url
   * @returns {Promise}
   */
  function warmCache(url) {
    return fetch(url, { mode: 'cors', credentials: 'omit' })
      .then(function (reponse) { return reponse.blob(); })
      .catch(function () {});
  }

  // ---------------------------------------------------------------------
  // GLINT-3D: activation automatique du modele 3D
  // ---------------------------------------------------------------------

  /**
   * GLINT-3D: renvoie le conteneur de defilement reel, ou null si c'est la
   * fenetre (.page-wrapper existe partout mais ne defile qu'en bureau).
   * @returns {Element|null}
   */
  function findScroller() {
    var wrapper = document.querySelector('.page-wrapper');
    if (!wrapper) return null;
    if (wrapper.scrollHeight <= wrapper.clientHeight + 1) return null;
    var overflowY = getComputedStyle(wrapper).overflowY;
    return overflowY === 'auto' || overflowY === 'scroll' ? wrapper : null;
  }

  /**
   * GLINT-3D: declenche l'ouverture du modele 3D en simulant le clic sur le
   * bouton poster natif — exactement le chemin d'un clic reel.
   * @param {Element} host - l'element <product-model>
   */
  function autoActivate(host) {
    if (host.getAttribute('data-media-loaded')) return; // GLINT-3D: deja ouvert
    if (host.dataset.glintAutoActivated === 'true') return;

    // GLINT-3D: ignore les instances masquees (galerie zoom, variantes non
    // affichees) : les activer telechargerait le modele plusieurs fois.
    var rect = host.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return;

    var button = host.querySelector('.deferred-media__poster-button');
    if (!button) return;

    host.dataset.glintAutoActivated = 'true'; // GLINT-3D

    /* GLINT-3D (28/08) : si le prechauffage est en route, on le laisse
       finir. Le visiteur regarde la photo du tirage pendant ce temps —
       et le modele apparait d'un coup, deja charge, au lieu de doubler
       le telechargement. */
    if (prechauffage) {
      var enAttente = prechauffage;
      prechauffage = null;
      enAttente.then(function () { ouvrirModele(host, button); });
      return;
    }

    ouvrirModele(host, button);
  }

  /**
   * GLINT-3D: le clic reel sur le bouton poster, defilement neutralise.
   * @param {Element} host
   * @param {Element} button
   */
  function ouvrirModele(host, button) {
    // GLINT-3D: le theme appelle content.focus() en ouvrant le media, ce qui
    // ferait sauter la page jusqu'a la vignette 3D sans que le visiteur l'ait
    // demande. On neutralise le defilement du focus, pas le focus lui-meme.
    var originalFocus = HTMLElement.prototype.focus;

    var scroller = findScroller();
    var scrollTop = scroller ? scroller.scrollTop : window.scrollY;

    /* GLINT-3D (28/08, bug client : « ca nous teleporte a la vignette 3D a
       la fin du chargement ») : neutraliser le focus le temps du clic ne
       suffit PAS. L'ouverture est synchrone, mais le saut arrive plus tard
       — quand model-viewer s'initialise et prend le focus, et parce que
       .page-wrapper porte scroll-behavior: smooth, le glissement est alors
       DEJA en vol quand notre filet de securite s'execute. On tient donc la
       position pendant toute la phase d'initialisation, et on lache des que
       le visiteur fait un geste : c'est lui qui commande, jamais nous. */
    verrouillerPosition(scroller, scrollTop, host);

    HTMLElement.prototype.focus = function (options) {
      var opts = {};
      if (options) {
        for (var key in options) opts[key] = options[key];
      }
      opts.preventScroll = true; // GLINT-3D
      return originalFocus.call(this, opts);
    };

    try {
      button.click();
    } finally {
      HTMLElement.prototype.focus = originalFocus; // GLINT-3D: retabli aussitot
    }

    /* GLINT-3D (28/08) : le theme donne le focus au media qu'il ouvre. Sur
       une ouverture AUTOMATIQUE personne n'a rien demande — et le polyfill
       focus-visible du theme dessine alors un contour orange autour de la
       piece, visible sur capture. On rend le focus au document : le clavier
       retrouve son ordre naturel, et la piece reste propre. */
    /* GLINT-3D (28/08, vu sur capture) : une seule passe ne suffisait pas.
       Le contour revient parce que model-viewer prend le focus quand LUI
       s'initialise — plusieurs secondes apres notre clic, une fois le GLB
       telecharge. On repasse donc pendant toute la phase de montage, et
       on s'arrete au premier geste du visiteur : le focus qu'IL demande
       lui appartient, on ne le lui reprend jamais. */
    var gesteDuVisiteur = false;
    var noterLeGeste = function () { gesteDuVisiteur = true; };
    ['pointerdown', 'keydown', 'touchstart'].forEach(function (nom) {
      window.addEventListener(nom, noterLeGeste, { once: true, passive: true, capture: true });
    });

    var rendreLeFocus = function () {
      if (gesteDuVisiteur) return;
      var actif = document.activeElement;
      if (actif && actif !== document.body && host.contains(actif) && typeof actif.blur === 'function') {
        actif.blur();
      }
    };

    window.requestAnimationFrame(rendreLeFocus);
    [120, 400, 1200, 3000, 6000].forEach(function (delai) {
      window.setTimeout(rendreLeFocus, delai);
    });
  }

  /**
   * GLINT-3D: maintient la page ou elle est pendant qu'un modele 3D se monte
   * tout seul. Rend la main au PREMIER geste du visiteur, au chargement du
   * modele (+ une marge), et au plus tard apres huit secondes.
   *
   * @param {Element|null} scroller - le conteneur de defilement, ou null pour la fenetre
   * @param {number} position - la position a tenir
   * @param {Element} host - l'element <product-model> qui se monte
   */
  function verrouillerPosition(scroller, position, host) {
    var conteneur = scroller || document.scrollingElement || document.documentElement;

    /* Ecrire scrollTop sur un conteneur en scroll-behavior: smooth relance
       une animation au lieu de poser la valeur — la lecon de l'aimantation
       de l'accueil. On coupe donc le lissage pendant le verrou. */
    var lissageSauve = conteneur.style.scrollBehavior;
    conteneur.style.scrollBehavior = 'auto';

    var gestes = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    var relache = false;
    var frame = 0;

    function rendreLaMain() {
      if (relache) return;
      relache = true;
      conteneur.style.scrollBehavior = lissageSauve;
      gestes.forEach(function (nom) {
        window.removeEventListener(nom, rendreLaMain);
      });
      if (frame) window.cancelAnimationFrame(frame);
    }

    gestes.forEach(function (nom) {
      window.addEventListener(nom, rendreLaMain, { passive: true });
    });

    var limite = Date.now() + 8000;

    function tenir() {
      if (relache) return;

      if (Date.now() > limite) {
        rendreLaMain();
        return;
      }

      var actuel = scroller ? scroller.scrollTop : window.scrollY;
      if (Math.abs(actuel - position) > 2) {
        if (scroller) {
          scroller.scrollTop = position;
        } else {
          window.scrollTo(window.scrollX, position);
        }
      }

      frame = window.requestAnimationFrame(tenir);
    }

    frame = window.requestAnimationFrame(tenir);

    /* Le modele est peint : l'initialisation est finie, plus rien ne devrait
       vouloir defiler. On laisse une marge de securite puis on rend la main. */
    var viewer = host.querySelector('model-viewer');
    var surCharge = function () {
      window.setTimeout(rendreLaMain, 700);
    };

    if (viewer) {
      viewer.addEventListener('load', surCharge, { once: true });
    } else {
      var guet = new MutationObserver(function () {
        var neuf = host.querySelector('model-viewer');
        if (!neuf) return;
        guet.disconnect();
        neuf.addEventListener('load', surCharge, { once: true });
      });
      guet.observe(host, { childList: true, subtree: true });
      window.setTimeout(function () { guet.disconnect(); }, 8000);
    }
  }

  /**
   * GLINT-3D: met en place l'activation automatique selon le reglage de
   * theme ("off" / "visible" / "load").
   */
  function setupAutoplay() {
    var hosts = document.querySelectorAll('product-model[data-glint-autoplay]');
    if (!hosts.length) return;

    var mode = hosts[0].dataset.glintAutoplay;
    if (!mode || mode === 'off') return; // GLINT-3D: comportement natif conserve

    // GLINT-3D: sur mobile, activer le 3D automatiquement impose ~8 Mo de
    // modele + ~6,5 Mo de HDRI avant meme que le visiteur ait demande quoi
    // que ce soit. On revient donc au clic natif sur petit ecran.
    if (hosts[0].dataset.glintAutoplayMobile !== 'true' && window.innerWidth < 750) {
      return;
    }

    if (mode === 'load') {
      hosts.forEach(autoActivate);
      return;
    }

    if (typeof IntersectionObserver !== 'function') {
      hosts.forEach(autoActivate);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          autoActivate(entry.target);
          io.unobserve(entry.target);
        });
      },
      /* GLINT-3D (28/08) : la vignette 3D fait maintenant toute la largeur
         et touche le bas de l'ecran a l'arrivee. Une marge de 200 px
         l'aurait ouverte d'office ; on exige donc qu'un tiers de la
         vignette soit reellement visible — le visiteur a scrolle. */
      { rootMargin: '0px', threshold: 0.34 }
    );

    hosts.forEach(function (host) {
      io.observe(host);
    });
  }

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    // GLINT-3D: rattrapage si un <model-viewer> existe deja au moment ou ce
    // script s'execute (ex. navigation retour/avant avec cache).
    document.querySelectorAll('model-viewer').forEach(applyGlintEnvironment);

    setupAutoplay(); // GLINT-3D

    // GLINT-3D: le prechargement attend le chargement complet de la page pour
    // ne disputer la bande passante a aucune ressource critique.
    if (document.readyState === 'complete') {
      schedulePreload();
    } else {
      window.addEventListener('load', schedulePreload, { once: true });
    }
  }

  /**
   * GLINT-3D: arme le prechauffage du modele et de la HDRI.
   */
  function schedulePreload() {
    var hosts = document.querySelectorAll('product-model[data-glint-preload-env="true"]');
    if (!hosts.length) return;

    /* GLINT-3D (28/08, retour client) : sur mobile la 3D ne s'ouvre que
       sur tap — mais le fichier, lui, doit deja etre la quand le doigt
       arrive, sinon on attend 8 Mo devant un cadre vide (« avant on ne
       perdait pas de temps quand on arrivait dessus »). Le prechauffage
       vaut donc pour TOUS les ecrans ; ce qui a disparu, c'est seulement
       de l'imposer a l'arrivee : il part au premier geste, donc jamais
       pour qui rebondit. */

    /* GLINT-3D (28/08, 3e passe — decision client : « je veux la voir
       deja libre, deja chargee quand il tombe dessus, sans l'icone »).
       Le prechauffage repart donc DES QUE LA PAGE EST AFFICHEE (start()
       nous appelle sur l'evenement load, et on attend le premier temps
       mort) : le chemin critique — l'image du tirage — reste intact,
       mais la piece est prete avant que le visiteur n'y arrive.
       slowConnection() protege toujours la 3G et le mode economie de
       donnees : la 3D y redevient un simple clic. */
    idle(function () { preloadEnvironment(hosts[0]); });
  }

  /** GLINT-3D: execute au premier temps mort du navigateur. */
  function idle(fn) {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(fn, { timeout: 3000 });
    } else {
      setTimeout(fn, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(); // GLINT-3D
